import styles from './ui.module.css';

/**
 * Тумблер Мезы.
 *
 * Свой, а не вкуишный, по той же причине, что и `Select`: платформа рисует
 * ЗАЛИТУЮ дорожку с тёмной ручкой, а в макете это контур со свечением и
 * бирюзовой ручкой на тёмном. Токенами это не выдаётся до конца — цвета
 * дорожки и ручки у VKUI публичные, а вот показать обводку у ВКЛЮЧЁННОГО
 * тумблера может только его внутренняя переменная видимости.
 *
 * Внутри настоящий `<input type="checkbox" role="switch">` — прозрачный и во
 * всю коробку: с ним работают клавиатура, фокус и скринридер, а `role`
 * говорит читалке, что это переключатель, а не галочка. Своё только видимое:
 * дорожка и ручка.
 */
export function Toggle({
  checked,
  disabled,
  label,
  onChange,
}: {
  checked: boolean;
  disabled?: boolean;
  /** Имя переключателя для скринридера: видимой подписи у него нет. */
  label: string;
  onChange: (checked: boolean) => void;
}) {
  return (
    <span className={styles.toggle}>
      <input
        type="checkbox"
        role="switch"
        className={styles.toggleInput}
        checked={checked}
        disabled={disabled}
        aria-label={label}
        // Состояние у нативной галочки и так своё, но с role="switch" линтер
        // требует назвать его явно — и он прав: роль мы поменяли руками.
        aria-checked={checked}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span className={styles.toggleTrack}>
        <span className={styles.toggleHandle} />
      </span>
    </span>
  );
}
